export default "__VITE_ASSET__Cc5iB410__"